export default "__VITE_ASSET__2b26cb2f__"